import domready from "domready";
import "../vendor/clamp";

function sliceListElements(element, maxElements) {
  var children = element.children;
  for (var i = children.length - 1; i >= maxElements; --i) {
    children[i].remove();
  }
}

domready(function () {
  var maxBlogCardLines = 3;
  var blogTexts = document.getElementsByClassName("blog-card__text");
  if (blogTexts !== null) {
    Array.prototype.forEach.call(blogTexts, function (el) {
      $clamp(el, {
        clamp: maxBlogCardLines
      });
    });
  }
  var maxEventCardLines = 3;
  var eventTexts = document.querySelectorAll(".event__info > p");
  if (eventTexts !== null) {
    Array.prototype.forEach.call(eventTexts, function (el) {
      $clamp(el, {
        clamp: maxEventCardLines
      });
    });
  }
  var maxTripCardLines = 5;
  var tripCardTexts = document.querySelectorAll(".trip-card__content > p, .trip-card__content > ol, .trip-card__content > ul");
  if (tripCardTexts !== null) {
    Array.prototype.forEach.call(tripCardTexts, function (el) {
      switch (el.tagName.toLowerCase()) {
        case "p":
          if (el.classList.length === 0) {
            $clamp(el, {
              clamp: maxTripCardLines
            });
          }
          break;
        case "ol":
          el.classList.add("list");
          sliceListElements(el, maxTripCardLines);
          break;
        case "ul":
          el.classList.add("list");
          sliceListElements(el, maxTripCardLines);
          break;
      }
    });
  }
});
